import React from 'react';
import Gallery from './components/Gallery';
import './App.css';

function App() {
  return (
    <div className="App">
      <Gallery />
    </div>
  );
}

export default App;

